<div class="h-full w-full bg-slate-100 gap-4 flex flex-col justify-center items-center text-xl" style="color: var(--color-blue-600);">
    <mat-spinner ngClass="h-2"></mat-spinner>
    {{mensajeApp}}
</div>